import { coordToLatLng } from './coordToLatLng';
import { calculateMarkerDistance } from './calculateMarkerDistance';

export function teleportAndLookAtMarker (panoramaInstance, markerCoords) {
    if (!panoramaInstance || !markerCoords) {
        console.warn("Invalid panoramaInstance or coordinates");
        return null;
    }
    
    if (!window.google.maps) {
        console.warn("Maps API not loaded");
        return null;
    }

    const targetLatLng = coordToLatLng(markerCoords);
    panoramaInstance.setPosition(targetLatLng);
    
    setTimeout(() => {
        const cameraPosition = panoramaInstance.getPosition();
        
        const distance = calculateMarkerDistance(cameraPosition, targetLatLng);
    
        if (distance < 1) { // Can't calculate heading if the camera is too close to the marker
            panoramaInstance.setPov({
                heading: panoramaInstance.getPov().heading,
                pitch: -45,
                zoom: 1
            });
        } else {
            const newHeading = window.google.maps.geometry.spherical.computeHeading(
                cameraPosition, 
                targetLatLng
            );

            panoramaInstance.setPov({
                heading: newHeading,
                pitch: 0,
                zoom: 1
            });
        }
    }, 200); // Timeout to ensure the panorama has updated its position before calculating the heading
}
